//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Morse",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "25", name: "有" },
        { value: "0", name: "无" },
      ],
      dataList1: [
      { value: "15", name: "有" },
      { value: "0", name: "无" },
      ],
      dataList2: [
        { value: "0", name: "卧床休息、活动有护理人员照顾或者无需使用辅助用具" },
        { value: "15", name: "使用拐杖、手杖、助行器" },
        { value: "30", name: "扶身边家具行走" },
      ],
      dataList3: [
      { value: "20", name: "有" },
      { value: "0", name: "无" },
      ],
      dataList4: [
        { value: "0", name: "正常或卧床休息不能活动" },
        { value: "10", name: "双下肢无力" },
        { value: "20", name: "残疾或功能障碍" },
      ],
      dataList5: [
        { value: "0", name: "能够量力而行" },
        { value: "15", name: "逞强或忘记自己受限制" },
      ],
      
     
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Morse.vue